const defaultValue = {
  'object': 'value',
  'document': {
    'object': 'document',
    'data': {},
    'nodes': [
      {
        'object': 'block',
        'type': 'paragraph',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': 'After ',
                'marks': [],
              },
              {
                'object': 'leaf',
                'text': 'Trump berated drug companies',
                'marks': [
                  {
                    'object': 'mark',
                    'type': 'bold',
                    'data': {},
                  },
                ],
              },
              {
                'object': 'leaf',
                'text': " for allegedly gouging Americans on drug prices, the drug industry's response has become a model of exactly ",
                'marks': [],
              },
              {
                'object': 'leaf',
                'text': "how companies can deflect Trump's twitter tirades.",
                'marks': [
                  {
                    'object': 'mark',
                    'type': 'bold',
                    'data': {},
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'paragraph',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': 'In July, Trump tweeted:',
                'marks': [],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'tweet',
        'isVoid': true,
        'data': {
          'provider_url': 'https://twitter.com',
          'cache_age': '3153600000',
          'width': 550,
          'height': null,
          'html': '<blockquote class="twitter-tweet" data-width="550"><p lang="en" dir="ltr">Pfizer &amp; others should be ashamed that they have raised drug prices for no reason. They are merely taking advantage of the poor &amp; others unable to defend themselves, while at the same time giving bargain basement prices to other countries in Europe &amp; elsewhere. We will respond!</p>&mdash; Donald J. Trump (@realDonaldTrump) <a href="https://twitter.com/realDonaldTrump/status/1016368503723577344?ref_src=twsrc%5Etfw">July 9, 2018</a></blockquote>\n',
          'url': 'https://twitter.com/realDonaldTrump/status/1016368503723577344',
          'version': '1.0',
          'provider_name': 'Twitter',
          'type': 'rich',
          'author_url': 'https://twitter.com/realDonaldTrump',
          'author_name': 'Donald J. Trump',
        },
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': '',
                'marks': [],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'paragraph',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': '... and the industry responded by rolling back several price hikes. An apparent coup for the administration.',
                'marks': [],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'paragraph',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': 'But behind the headlines',
                'marks': [
                  {
                    'object': 'mark',
                    'type': 'bold',
                    'data': {},
                  },
                  {
                    'object': 'mark',
                    'type': 'italic',
                    'data': {},
                  },
                ],
              },
              {
                'object': 'leaf',
                'text': ', industry concessions were ',
                'marks': [],
              },
            ],
          },
          {
            'object': 'inline',
            'type': 'link',
            'isVoid': false,
            'data': {
              'href': 'https://www.politico.com/story/2018/08/03/trump-drug-prices-companies-721145',
            },
            'nodes': [
              {
                'object': 'text',
                'leaves': [
                  {
                    'object': 'leaf',
                    'text': 'token gestures',
                    'marks': [],
                  },
                ],
              },
            ],
          },
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': ' that did little to change how they did business. For example:',
                'marks': [],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'bulleted-list',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'block',
            'type': 'list-item',
            'isVoid': false,
            'data': {},
            'nodes': [
              {
                'object': 'text',
                'leaves': [
                  {
                    'object': 'leaf',
                    'text': 'Companies targeted old products that no longer produced much revenue.',
                    'marks': [],
                  },
                ],
              },
            ],
          },
          {
            'object': 'block',
            'type': 'list-item',
            'isVoid': false,
            'data': {},
            'nodes': [
              {
                'object': 'text',
                'leaves': [
                  {
                    'object': 'leaf',
                    'text': 'They simply paused price changes for six months, ',
                    'marks': [],
                  },
                  {
                    'object': 'leaf',
                    'text': "just long enough to wait out Trump's latest fixation",
                    'marks': [
                      {
                        'object': 'mark',
                        'type': 'bold',
                        'data': {},
                      },
                    ],
                  },
                  {
                    'object': 'leaf',
                    'text': '!',
                    'marks': [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'paragraph',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': "The industry’s deft response is a test of whether Trump's administration is serious about following up with an aggressive crackdown on the companies or will simply declare victory based on token measures and move on.",
                'marks': [],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'heading-three',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': 'So will they?',
                'marks': [],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'paragraph',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': 'If you ask drug lobbyists, the industry is expecting Trump to take the media win and leave it at that.',
                'marks': [],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'blockquote',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'block',
            'type': 'paragraph',
            'isVoid': false,
            'data': {},
            'nodes': [
              {
                'object': 'text',
                'leaves': [
                  {
                    'object': 'leaf',
                    'text': 'A lot of this shit is meaningless to satisfy Trump.',
                    'marks': [],
                  },
                ],
              },
            ],
          },
          {
            'object': 'block',
            'type': 'paragraph',
            'isVoid': false,
            'data': {},
            'nodes': [
              {
                'object': 'text',
                'leaves': [
                  {
                    'object': 'leaf',
                    'text': '- Drug lobbyist',
                    'marks': [
                      {
                        'object': 'mark',
                        'type': 'small',
                        'data': {},
                      },
                      {
                        'object': 'mark',
                        'type': 'italic',
                        'data': {},
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'paragraph',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': "Analysts broadly agree recent concessions won’t hurt bottom lines or rein in drug prices beyond this six-month period. That's because many companies already increased prices this year — in some cases, ",
                'marks': [],
              },
              {
                'object': 'leaf',
                'text': 'just weeks',
                'marks': [
                  {
                    'object': 'mark',
                    'type': 'bold',
                    'data': {},
                  },
                ],
              },
              {
                'object': 'leaf',
                'text': ' before publicly pledging to freeze them for the rest of 2018.',
                'marks': [],
              },
            ],
          },
        ],
      },
      {
        'object': 'block',
        'type': 'paragraph',
        'isVoid': false,
        'data': {},
        'nodes': [
          {
            'object': 'text',
            'leaves': [
              {
                'object': 'leaf',
                'text': 'And ',
                'marks': [],
              },
              {
                'object': 'leaf',
                'text': 'that',
                'marks': [
                  {
                    'object': 'mark',
                    'type': 'italic',
                    'data': {},
                  },
                ],
              },
              {
                'object': 'leaf',
                'text': ' may finally be how you win a Twitter fight with the Trump administration.',
                'marks': [],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default defaultValue;
